<div class="row" *ngIf="profileData">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title"> {{ 'PRODUCT.PRODUCT_DATA' | translate }}</div>
                <div class="tools">
                    <!-- <button type="button" class="btn btn-primary btn-sm" (click)="onEdit()">
                        <i class="bi bi-pencil-square"></i> Редактировать данные
                    </button> -->
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'DENOMINATION' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.product_name}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'DIALOG.PRICE.OLD_PRICE' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.prices_info.old_price}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'DIALOG.PRICE.CURRENT_PRICE' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.prices_info.price}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'DIALOG.PRICE.PREMIUM_PRICE' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.prices_info.premium_price}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'DIALOG.PRICE.DIMENSIONAL_UNIT' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.prices_info.dimension_unit}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'DIALOG.PRICE.WEIGHT_UNIT' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.prices_info.weight_unit}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'ORGANIZATION.VAT' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.prices_info.vat}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'FILES.DATE_OF_CREATE' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.create_date}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'PRICE.DATE_THE_INVITATION' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.sending_date}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'STATUS' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.state.name}}</div>
                    </div>
                </div>
                <div class="row" *ngIf="profileData.state.id == 'ERROR' || profileData.state.id == 'FULL_REPORT_ERROR'">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'COUSE_OF_ERROR' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.errors}}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="loading" *ngIf="!profileData">
    <div *ngIf="profileData"> {{ 'LOADING' | translate }}</div>
    <div *ngIf="!profileData">{{ 'DATA_NOT_FOUND' | translate }}</div>
</div>